<template>
    <div class="clientContent">
        <div class="clientTitle">
            {{$translate('lang.E3202103030012', { defaultText: '用户服务' })}}
            <span class="line lineMore"></span>
        </div>
        <el-tabs @tab-click="handleClick" v-model='activeName'>
            <el-tab-pane :label="$translate('lang.E3202103030068', { defaultText: '售后安装' })" name="first">
                <div class="content">
                    <div class="main">
                        <div class="mainContent" v-for="(item2, index) in list" :key='index'>
                            <div class="iconText">{{item2.label}}</div>
                            <el-row class="commomPaper itemMain">
                                <el-col :span='item.span' class="itemRow" v-for="(item,index) in item2.makeList" :key='index'>
                                    <div class="labelText" :title='item.label' :style="'min-width:' + item.width + 'px;'">{{item.label}}</div>
                                    <el-tooltip effect="dark" :content='afterInstallation[item.key]' placement="top"
                                        v-if='afterInstallation[item.key] && afterInstallation[item.key].length > 34'>
                                        <span class="valueText unitValueText">{{afterInstallation[item.key]}}</span>
                                    </el-tooltip>
                                    <div class="valueText" v-else>{{afterInstallation[item.key]}}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$translate('lang.E3202103030069', { defaultText: '售后维修' })" name="second">
                <div class="content">
                    <div class="main">
                        <div class="mainContent" v-for="(item2, index) in list.slice(0, 2)" :key='index'>
                            <div class="iconText">{{item2.label}}</div>
                            <el-row class="commomPaper itemMain">
                                <el-col :span='makeListitem.span' class="itemRow" v-for="(makeListitem, makeListindex) in item2.makeList" :key='makeListindex'>
                                    <div class="labelText" :title='makeListitem.label' :style="'min-width:' + makeListitem.width + 'px;'">{{makeListitem.label}}</div>
                                    <el-tooltip effect="dark" :content='afterSalesRepair[makeListitem.key]' placement="top"
                                        v-if='afterSalesRepair[makeListitem.key] && afterSalesRepair[makeListitem.key].length > 34'>
                                        <span class="valueText unitValueText">{{afterSalesRepair[makeListitem.key]}}</span>
                                    </el-tooltip>
                                    <div class="valueText">{{afterSalesRepair[makeListitem.key]}}</div>
                                </el-col>
                                <el-col class="itemRow" :span='8' v-if="index === 1">
                                    <div class="labelText" :title="$translate('lang.E3202103030055', { defaultText: '保修类型' })" :style="'min-width:60px;'">
                                        {{$translate('lang.E3202103030055', { defaultText: '保修类型' })}}
                                    </div>
                                    <el-tooltip effect="dark" :content="afterSalesRepair['warrantyTypeCode']" placement="top"
                                        v-if="afterSalesRepair['warrantyTypeCode'] && afterSalesRepair['warrantyTypeCode'].length > 34">
                                        <span class="valueText unitValueText">{{afterSalesRepair['warrantyTypeCode']}}</span>
                                    </el-tooltip>
                                    <div class="valueText">{{afterSalesRepair['warrantyTypeCode']}}</div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="mainContent">
                            <div class="iconText">{{$translate('lang.E3202103030071', { defaultText: '维修信息' })}}
                                <span class="fixNumber">({{listRepair.length}})</span>
                            </div>
                            <div>
                                <div v-if='listRepair.length > 0'>
                                    <el-row class="commomPaper itemMain" v-for="(item2, index) in listRepair" :key='index + "info2"'>
                                        <el-col :span='item.span' class="itemRow" v-for="(item,index) in item2.makeList" :key='index'>
                                            <div class="labelText" :title='item.label' :style="'min-width:' + item.width + 'px;'">{{item.label}}</div>
                                            <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                                                <span class="valueText unitValueText">{{item.value}}</span>
                                            </el-tooltip>
                                            <div class="valueText" v-else>{{item.value}}</div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div v-else>
                                    <el-row class="commomPaper itemMain" v-for="(item2, index) in defaultRepair" :key='index + "info2"'>
                                        <el-col :span='item.span' class="itemRow" v-for="(item,index) in item2.makeList" :key='index'>
                                            <div class="labelText" :title='item.label' :style="'min-width:' + item.width + 'px;'">{{item.label}}</div>
                                            <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                                                <span class="valueText unitValueText">{{item.value}}</span>
                                            </el-tooltip>
                                            <div class="valueText" v-else>{{item.value}}</div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$translate('lang.E3202103030070', { defaultText: '使用连接' })" name="third">
                <el-row>
                    <el-col :span='item.span' class="itemRow" v-for="(item,index) in clientConnect" :key='index'>
                        <div class="labelText" :title='item.label'>{{item.label}}</div>
                        <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'>
                            <span class="valueText unitValueText">{{item.value}}</span>
                        </el-tooltip>
                        <div
                            class="valueText"
                            v-else
                            :class='[item.active === 1?"activeColor":"",item.value === 0?"unactiveColor":""]'>
                            {{item.value}}
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { searchProClientInstall, searchProClientConnect } from '../../../../api/productProcess.js';
import { list, listBar } from './js/client.js';
export default {
    props: {
    },
    data () {
        return {
            activeName: 'first',
            proNum: '',
            flag: false,
            listRepair: [],
            list,
            listBar,
            defaultRepair: [listBar],
            clientConnect: [{
                span: 8,
                label: this.$translate('lang.E3202103030080', { defaultText: '激活状态' }),
                value: '',
                key: 'activeStatus',
                active: 0
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030081', { defaultText: '激活时间' }),
                value: '',
                key: 'activeTime'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030082', { defaultText: '省份' }),
                value: '',
                key: 'provinceName'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030083', { defaultText: '城市' }),
                value: '',
                key: 'cityName'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030084', { defaultText: '设备条码' }),
                value: '',
                key: 'tsn'
            }, {
                span: 8,
                label: this.$translate('lang.E3202103030085', { defaultText: '设备ID' }),
                value: '',
                key: 'applianceId'
            }],
            afterInstallation: {},
            afterSalesRepair: {}
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initData() {
            this.activeName = 'first';
            this.listRepair = [];
            this.afterSalesRepair = {};
            this.afterInstallation = {};
            this.list.map(item => {
                item.makeList.forEach(item2 => {
                    item2.value = '';
                });
            });
        },
        initData2() {
            this.listBar.makeList.forEach(item => {
                item.value = '';
            });
        },
        setproNum(proNum) {
            this.initData();
            this.initData2();
            this.proNum = proNum;
            this.flag = true;
        },
        // 获取客户详细信息
        getMessage() {
            if (this.flag) {
                searchProClientInstall(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        if (res.data.installArchive) {
                            this.afterInstallation = res.data.installArchive;
                        }
                        if (res.data.repairArchiveList) {
                            this.afterSalesRepair = res.data.repairArchiveList[0];
                            const { repairArchiveList } = res.data;
                            // 售后维修
                            repairArchiveList.map((item, index) => {
                                this.initData2();
                                Object.keys(item).map(item2 => {
                                    this.listBar.makeList.forEach(item3 => {
                                        if (item2 === item3.key) {
                                            item3.value = item[item2];
                                        }
                                    });
                                    return item;
                                });
                                this.listRepair.push(JSON.parse(JSON.stringify(this.listBar)));
                            });
                            // 当售后安装缺失时，但存在维修信息时，用户，机器信息从这里取
                            Object.keys(repairArchiveList[0]).map(item => {
                                this.list.map((item2, index) => {
                                    if (index < 2) {
                                        item2.makeList.forEach(item3 => {
                                            if (item === item3.key) {
                                                item3.value = repairArchiveList[0][item];
                                            }
                                        });
                                    }
                                });
                                return item;
                            });
                        }
                    }
                    this.flag = false;
                });
                searchProClientConnect(this.proNum).then(res => {
                    this.clientConnect = this.$options.data.call(this).clientConnect;
                    if (res.code === '0' && res.data) {
                        const clientConnectObj = res.data;
                        Object.keys(clientConnectObj).map(item => {
                            this.clientConnect.forEach(item2 => {
                                if (item === item2.key) {
                                    item2.value = clientConnectObj[item];
                                }
                            });
                            return item;
                        });
                        if (this.clientConnect[0].value === '1') {
                            this.clientConnect[0].value = this.$translate('lang.E3202103040001', { defaultText: '已激活' });
                            this.clientConnect[0].active = 1;
                        } else {
                            this.clientConnect[0].value = this.$translate('lang.E3202103040002', { defaultText: '未激活' });
                            this.clientConnect[0].active = 0;
                        }
                    }
                    this.flag = false;
                });
            }
        }
    }
};
</script>
<style lang="less">
.clientContent {
    .clientTitle {
        position: absolute;
        top: 8px;
        left: 5px;
        font-weight: 700;
        color: #333;
    }
    .el-tabs__nav-wrap {
        box-sizing: border-box;
        padding-left: 140px;
    }
    .lineMore {
        margin-left: 42px;
    }
    .mainContent {
        margin-bottom: 15px;
        .iconText {
            font-size: 12px;
            height: 40px;
            line-height: 40px;
        }
        .fixNumber {
            color: #4285f5;
            font-size: 14px;
            padding-left: 3px;
        }
    }
    .itemMain {
        margin-bottom: 10px;
    }
    .activeColor {
        color: #FB3C3C !important;
        font-weight: 600;
    }
    .unactiveColor {
        color: #4285f5 !important;
        font-weight: 600;
    }
}
</style>
